import { render, staticRenderFns } from "./case-list.vue?vue&type=template&id=49f871d6&scoped=true&"
import script from "./case-list.vue?vue&type=script&lang=js&"
export * from "./case-list.vue?vue&type=script&lang=js&"
import style0 from "./case-list.vue?vue&type=style&index=0&id=49f871d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f871d6",
  null
  
)

export default component.exports